@use "app/styles/colors" as colors;

.section {
  display: flex;
  flex-direction: column;
  text-align: center;
  @include colors.section("green");

  h2 {
    font-size: max(2.8rem, min(3.3rem, 8dvw));
    margin-bottom: 1rem;
  }
}

.cards {
  display: grid;
  align-self: center;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 2.5rem;
  gap: 2.5rem;
  text-align: center;
  justify-items: center;
  max-width: fit-content;
  line-height: 1.8rem;
  @media (min-width: 64rem) {
    grid-template-columns: repeat(4, 1fr);
  }
}

.bluesky,
.discord,
.twitter,
.github {
  display: flex;
  max-width: 13rem;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-wrap: balance;

  &:hover .logo {
    animation: bounce 0.8s;
    @keyframes bounce {
      0% {
        transform: translateY(0);
      }
      10% {
        transform: translateY(0) scale(1.1, 0.9);
      }
      30% {
        transform: translateY(-20px) scale(0.95, 1.05);
      }
      40% {
        transform: translateY(0) scale(1.05, 0.95);
      }
      50% {
        transform: translateY(-10px) scale(0.98, 1.02);
      }
      70% {
        transform: translateY(0) scale(1.02, 0.98);
      }
      100% {
        transform: translateY(0);
      }
    }
  }

  span a {
    display: inline-flex;
    color: var(--section-color);
    background-color: var(--section-color-alt-dim);
    border-radius: 2.5rem;
    padding: 0.5rem 0.75ch;
    margin: 0.15rem 0;
    line-height: 0.5rem;
    text-decoration-line: none;

    &:hover {
      text-decoration-line: underline;
    }
  }
}

.bluesky {
  @include colors.section("blue");
}

.discord {
  @include colors.section("yellow");
}

.twitter {
  @include colors.section("red");
}

.github {
  @include colors.section("green");
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  width: 4rem;

  svg {
    height: 100%;
  }
}

.logo path {
  fill: var(--color-foreground);
}
